import * as React from 'react';

const CalendarIcon: React.FC<React.SVGProps<SVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
    className={props.className}
  >
    <path
      stroke="#FDD014"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
      d="M7.74 5.392v3.333h3.333M8 14A6 6 0 1 1 8 2a6 6 0 0 1 0 12"
    ></path>
  </svg>
);

export default CalendarIcon;
